import axios from "axios";
import * as Safe from "safe-portals";

type Method = "get" | "post";

/**
 * Wrap a call to an external http json api, validating that the correct data
 * structure is passed in, and validating the expected response type.
 */
export function defineHttpJsonApi<IN, OUT, SetupArgs extends { host: string }>(
  method: Method,
  path: string,
  args: Safe.Obj<IN>,
  resp: Safe.Type<OUT>,
  headerFn?: (args: SetupArgs, path: string, inputs: IN) => { url: string; headers: any }
): (setupArgs: SetupArgs, a: IN) => Promise<OUT> {
  return async function (setupArgs: SetupArgs, a: IN): Promise<OUT> {
    const { url, headers } = headerFn ? headerFn(setupArgs, path, a) : { url: `${setupArgs.host}${path}`, headers: {} };

    try {
      switch (method) {
        case "get":
          return await axios.get(url, { params: args.write(a), headers }).then((r) => resp.read(r.data));
        case "post":
          return await axios.post(url, args.write(a), { headers }).then((r) => resp.read(r.data));
      }
    } catch (e) {
      if (e instanceof Safe.ValidationError) {
        throw new TypeError(`ValidationError accessing ${method.toUpperCase()} ${url}: ${e.message}`);
      }
      throw e;
    }
  };
}
